/* kitsters-pre-init.js - must run before custom.js (module scripts are deferred, so this fires first).
   Blanks Kalles wishlist icon strings so the dual-SVG hearts are not replaced with 0×0 sprites. */
(function () {
  var e = window.themeHDN;
  if (e && e.extras) {
    e.extras.icon_wis_add = e.extras.icon_wis_adding = e.extras.icon_wis_added = e.extras.icon_wis_remove = '';
  }
})();
